import { render } from "./EmptyInitData.vue?vue&type=template&id=5a95243c&scoped=true"
import script from "./EmptyInitData.vue?vue&type=script&lang=js"
export * from "./EmptyInitData.vue?vue&type=script&lang=js"

import "./EmptyInitData.vue?vue&type=style&index=0&id=5a95243c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a95243c"]])

export default __exports__